import { ActionIcon, Box, Select, Text, Textarea, TextInput } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';

import { useContentCategoryOptions } from '../../hooks/useContentCategoryOptions';

import { ScriptDraft, ScriptRowErrors } from './types';

type Props = {
  pageId: string;
  index: number;
  row: ScriptDraft;
  errors?: ScriptRowErrors;
  canRemove: boolean;
  onChange: (patch: Partial<ScriptDraft>) => void;
  onRemove: () => void;
};

export const ScriptRow = ({ pageId, index, row, errors, canRemove, onChange, onRemove }: Props) => {
  const categoryOptions = useContentCategoryOptions(pageId);
  return (
    <Box
      style={{
        display: 'grid',
        gridTemplateColumns: '32px minmax(180px, 1fr) minmax(280px, 2fr) 200px 40px',
        gap: 12,
        alignItems: 'start',
        padding: '12px 0',
        borderBottom: '1px solid var(--mantine-color-dark-5)',
      }}
    >
      <Text pt={10} size="sm" c="dimmed" ta="center">
        {index}
      </Text>
      <TextInput
        placeholder="Название скрипта"
        value={row.name}
        onChange={(event) => onChange({ name: event.currentTarget.value })}
        error={errors?.name}
      />
      <Textarea
        placeholder="Текст скрипта..."
        value={row.textContent}
        onChange={(event) => onChange({ textContent: event.currentTarget.value })}
        autosize
        minRows={3}
        error={errors?.textContent}
      />
      <Select
        placeholder="Категория"
        data={categoryOptions}
        value={row.category || null}
        onChange={(value) => onChange({ category: value ?? '' })}
        comboboxProps={{ withinPortal: true }}
        searchable
        clearable
      />
      <Box pt={6}>
        <ActionIcon
          variant="subtle"
          color="gray"
          radius="md"
          onClick={onRemove}
          disabled={!canRemove}
          aria-label="Удалить строку"
        >
          <IconTrash size={18} />
        </ActionIcon>
      </Box>
    </Box>
  );
};
